import { call, put, select, take, takeEvery } from 'redux-saga/effects';
import { GlobalActions, GlobalPut } from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { isExtremwetterUWProcessNecessary, selectFeatureToggle } from '@ps20-frontend/selector';
import { UwContext } from '@ps20-frontend/uw';
import { Feature } from '@ps20/bff-models';
import { VwgActions } from '../vwgActions';
import { IAppState } from '../appState';
import {
  isUwProzessForNebengebaeudeNecessary,
  mapStateToPremiumAndExtremwetterDisabledSelectorTo
} from '../../app/shared/selectors/produkt.selector';

export function* watchConfirmUwApprovedOfferEdition() {
  yield takeEvery(
    GlobalActions.CONFIRM_UW_APPROVED_OFFER_EDITION,
    safeSaga(confirmUwApprovedOfferEdition, App.VWG_V2),
  );
}

export function* confirmUwApprovedOfferEdition(action: {
  type: string;
  payload?: { appId: App; angebotsId: string };
}) {
  const globalPut = GlobalPut.getInstance();
  const { appId, angebotsId } = action.payload || { appId: null, angebotsId: null };

  const initialState: IAppState = yield select();

  if (appId !== App.VWG_V2 || angebotsId !== initialState.angebotsId) {
    return;
  }

  const selectedProduktlinie = initialState.produkt?.produktlinien?.find(linie => linie.selected);
  const hasWeitereNaturgefahren = selectedProduktlinie?.zusatzoptionen.some(
    item => item.id === 'weitereNaturgefahren' && item.isSelected,
  );
  const nebengebaeudeUeber200 = Boolean(
    selectFeatureToggle(initialState, Feature.UW_NEBENGEBAEUDE) &&
      isUwProzessForNebengebaeudeNecessary(initialState, initialState.vertragsoptionen),
  );

  const showElementarfragebogen = Boolean(
    hasWeitereNaturgefahren &&
      isExtremwetterUWProcessNecessary(
        mapStateToPremiumAndExtremwetterDisabledSelectorTo(initialState),
      ),
  );
  const requiredByContext = {
    [UwContext.NATURAL_HAZARDS]: showElementarfragebogen,
    [UwContext.OUTBUILDING]: nebengebaeudeUeber200,
  };

  if (!initialState.vertragsoptionen.beibehalten) {
    const needsResubmission = hasWeitereNaturgefahren || nebengebaeudeUeber200;

    if (needsResubmission) {
      yield call(
        globalPut.put,
        new GlobalActions().setNeedsUwResubmission(true, angebotsId, requiredByContext),
      );
    }
  }

  yield call(globalPut.put, new GlobalActions().setUnderwriterInfo(angebotsId, requiredByContext));

  yield put(new VwgActions().preiseRequested());

  yield take(GlobalActions.GESAMTPREIS_CHANGED);

  const state: IAppState = yield select();

  yield call(
    globalPut.put,
    new GlobalActions().createStreckeSnapshot({ appId: App.VWG_V2, angebotsId: state.angebotsId }),
  );

  yield call(globalPut.put, new GlobalActions().setEditingUwApprovedOffer(false));

  yield put(new VwgActions().absprungInsDashboard());
}
